export default "__VITE_ASSET__DMJG6udw__"